export default __webpack_public_path__ + "static/media/about us page_Innovation.2caf7863.png";